import React, {useState, useContext, useEffect} from 'react';
import Select from 'react-select';
import { UserRegistrationContext } from "./ShareStates";
import CustomerErrorMessage from "./CustomerErrorMessage";
import {
    getRegionList,
    getUserRegisterRegionQuery,
    getQueryResult
} from "../../commonFunctions/GraphqlFunctions";

const RegionForm = () => {
    const {
        serialNumber1,
        // serialNumber2,
        region,
        updateDisplayForm,
        updateRegion,
        updatePreviousForm
    } = useContext(UserRegistrationContext);
    const [regionValue, setRegionValue] = useState([]);
    const [regionListValue, setRegionListValue] = useState([]);
    const [regionValueError, setRegionValueError] = useState("");
    const [mountReadOnce, setMountReadOnce] = useState("none");
    const [displayErrorNotice, setDisplayErrorNotice] = useState("none");
    const [displayErrorNoticeCustomerValue, setDisplayErrorNoticeCustomerValue] = useState("none");
    const [displayErrorNoticeGraphQLValue, setDisplayErrorNoticeGraphQLValue] = useState("none");
    const [selectSingleValueTopValue, setSelectSingleValueTopValue] = useState("0%");
    const [selectSingleValuePositionValue, setSelectSingleValuePositionValue] = useState("");

    useEffect(() => {
        async function fetchData() {
            if (mountReadOnce === "none") {
                // console.log(country);
                let getRegionResult = await getCountriesListResult();
                // console.log(getRegionResult);
                if (getRegionResult !== undefined || getRegionResult !== null) {
                    if (getRegionResult.data['supportSiteUserGetRegion']['message'] !== undefined) {
                        let messageOutput = getRegionResult.data['supportSiteUserGetRegion']['message'];
                        console.log(messageOutput)
                        setDisplayErrorNoticeGraphQLValue("block");
                    }
                    else {
                        let regionList = getRegionResult.data['supportSiteUserGetRegion']['countries'];
                        let regionOptions = [];
                        for (let i = 0; i < regionList.length; i++) {
                            let region = regionList[i]['countryname']
                            regionOptions.push({value: region, label: region})
                        }
                        setRegionListValue(regionOptions);
                        setRegionValue(region);
                        setSelectSingleValueTopValue('50%');
                        setSelectSingleValuePositionValue('absolute');
                    }
                }
                else {
                    console.log(getRegionResult);
                    setDisplayErrorNoticeGraphQLValue("block");
                }
                setMountReadOnce("visited");
            }
        }
        async function getCountriesListResult() {
            return await getQueryResult(getRegionList(), {"getRegion": "True"})
        }
        fetchData();
        window.addEventListener('resize', removeSelectMenu);
    }, [mountReadOnce, region, setMountReadOnce, setRegionValue, setRegionListValue, setDisplayErrorNoticeGraphQLValue]);

    const removeSelectMenu = (event) => {
        //remove the focus on current active element and refocus on the window body
        window.focus();
        document.activeElement.blur();
    }

    const inputChange = (event) => {
        // event.preventDefault();
        setRegionValue(event);
        setSelectSingleValueTopValue('50%');
        setSelectSingleValuePositionValue('relative');
    }

    const getDisplayErrorNotice = (errorType, error) => {
        if (errorType === 'message') {
            console.log(error);
            setDisplayErrorNotice("block");
            setDisplayErrorNoticeCustomerValue("none");
            setDisplayErrorNoticeGraphQLValue("block");
        }
        if (errorType === 'customer') {
            setDisplayErrorNotice("block");
            setDisplayErrorNoticeCustomerValue("block");
            setDisplayErrorNoticeGraphQLValue("none");
        }
        if (errorType === 'none') {
            setDisplayErrorNotice("none");
            setDisplayErrorNoticeCustomerValue("none");
            setDisplayErrorNoticeGraphQLValue("none");
        }
    }

    const backButtonAction = (event) => {
        event.preventDefault();
        updateRegion(regionValue);
        updateDisplayForm("serialNumberForm");
    }

    const nextButtonAction = async (event) => {
        event.preventDefault();
        setRegionValueError("");
        let region = regionValue.value;
        if (region === undefined) {
            setRegionValueError("Please select an region");
        }
        else {
            if (region.trim() === "") {
                setRegionValueError("Please select an region");
            }
            else {
                let getUserRegisterRegionResult = await getQueryResult(
                    getUserRegisterRegionQuery(),
                    {"serialNumber1": serialNumber1, "region": region}
                )
                if (getUserRegisterRegionResult !== undefined) {
                    if (getUserRegisterRegionResult.data['supportSiteUserRegisterCheckRegion']['message'] !== undefined) {
                        let messageOutput = getUserRegisterRegionResult.data['supportSiteUserRegisterCheckRegion']['message'];
                        if (messageOutput === "no match region found") {
                            getDisplayErrorNotice("customer", messageOutput);
                        }
                        else {
                            getDisplayErrorNotice("message", messageOutput);
                        }
                    }
                    else {
                        let customerName = getUserRegisterRegionResult.data['supportSiteUserRegisterCheckRegion']['customer']
                        if (customerName === "") {
                            getDisplayErrorNotice("customer", "customer not found");
                        }
                        else {
                            updateRegion(regionValue);
                            updatePreviousForm('regionForm');
                            updateDisplayForm("accountForm");
                        }
                    }
                }
                else {
                    getDisplayErrorNotice("message", getUserRegisterRegionResult);
                }
            }
        }
    }

    const countryListStyle = {
        container: (provided) => ({
            ...provided,
            display: 'inline-block',
            minHeight: '1px',
            width: '100%',
            textAlign: 'left',
            border: 'none',
        }),
        control: (provided) => ({
            ...provided,
            border: '2px solid #ddd',
            borderRadius: '0',
            minHeight: '1px',
            height: '42px',
        }),
        input: (provided) => ({
            ...provided,
            minHeight: '1px',
            color: 'black',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            minHeight: '1px',
            paddingTop: '0',
            paddingBottom: '0',
            color: '#990000',
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            minHeight: '1px',
            height: '24px',
        }),
        clearIndicator: (provided) => ({
            ...provided,
            minHeight: '1px',
        }),
        valueContainer: (provided) => ({
            ...provided,
            minHeight: '1px',
            height: '40px',
            paddingTop: '0',
            paddingBottom: '0',
        }),
        singleValue: (provided, state) => ({
            ...provided,
            minHeight: '1px',
            position: selectSingleValuePositionValue,
            top: selectSingleValueTopValue
        }),
        placeholder: (provided) => ({
           ...provided,
           top: '45%',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#bbb': state.isFocused ? '#ddd': 'white',
            color: state.isSelected || state.isFocused ? 'white': 'black',
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
        })
    }

    return (
        <div>
            <React.Fragment>
                <fieldset name={"countryStep"} style={{display: "block"}}>
                    <h1>We need a little more information</h1>
                    <div className={"errorNotice"} style={{display: displayErrorNotice}}>
                        <div style={{display: displayErrorNoticeCustomerValue}}>
                            {CustomerErrorMessage()}
                        </div>
                        <div style={{display: displayErrorNoticeGraphQLValue}}>
                            There is error contacting the backend server, please contact administrator.
                        </div>
                    </div>
                    <Select
                        options={regionListValue}
                        placeholder={"Select your region"}
                        styles={countryListStyle}
                        theme={theme => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                primary: '#ddd'
                            },
                        })}
                        onChange={inputChange}
                        isMulti={false}
                        value={regionValue}
                        menuPortalTarget={document.body}
                        id={"countrySelectList"}
                        blurInputOnSelect={true}
                        maxMenuHeight={200}
                    />
                    <span id={"error_country"} className={"error"}>{regionValueError}</span>
                    <div style={{width: '100%'}}>
                        <div style={{width: '50%', float: 'left', paddingRight: '10px'}}>
                            <button type={"button"} className={"backButton btn"} title={"Next"} onClick={backButtonAction}>
                                <span>Back</span>
                            </button>
                        </div>
                        <div style={{width: '50%', float: 'right', paddingLeft: '10px'}}>
                            <button type={"submit"} className={"nextButton btn"} title={"Next"} onClick={nextButtonAction}>
                                <span>Next</span>
                            </button>
                        </div>
                        <div style={{clear: "both"}}></div>
                    </div>
                </fieldset>
            </React.Fragment>
        </div>
    )
}

export default RegionForm;